---
de:
  production_simulation_plan:
    axis_names:
      energy: Energie
      inflow_energy: Zulaufenergie
      price: Preis
      reservoir_energy: Speicherenergie
      volume: Volumen (MWh)
    chart_names:
      actual_market_price: Aktueller Marktpreis
      actual_production: Tatsächliche Produktion
      estimated_inflow: Geschätzter Zufluss
      estimated_price: Geschätzter Preis
      estimated_reservoir_volume: Geschätztes Speichervolumen
      past_planned_production: Vergangene geplante Produktion
      planned_production: Geplante Produktion
